import defaultsOrg from "../defaults"

const styles = (defaults: typeof defaultsOrg) => ({
    dimmed: {
        color: defaults.colors.neutrals["700"],
    },
})

export default styles
